export var DraftOrdersMapper = function (response) {
    return response;
};
export var GetDraftOrdersMapper = function (data) {
    return data;
};
export var SaveDraftOrdersMapper = function (data) {
    return data;
};
export var DraftOrderCountMapper = function (data) {
    return data;
};
export var DraftOrderDetailsMapper = function (data) {
    return data;
};
export var DraftOrderUpdateMapper = function (data) {
    return data;
};
export var DeletedDraftDocsMapper = function (data) {
    return data;
};
export var PreviewDocsMapper = function (data) {
    return data;
};
export var SaveDraftDocsMapper = function (data) {
    return data;
};
export var DraftOrderDeclarationMapper = function (data) {
    return data;
};
